import { computed, readonly, ref, Ref } from "vue";

type OrientationType = "landscape" | "portrait";

let isInitialized = false;
let orientationRef: Ref<OrientationType> = null;

function initialize() {
    if (isInitialized) return;

    orientationRef = ref<OrientationType>("portrait");
    const mql = window.matchMedia("(orientation: portrait)");
    orientationRef.value = mql.matches ? "portrait" : "landscape";
    mql.onchange = (e) => {
        orientationRef.value = e.matches ? "portrait" : "landscape";
    };

    isInitialized = true;
}

export function useScreenOrientation() {
    initialize();

    const orientation = readonly(orientationRef);
    const isLandscape = computed(() => orientationRef.value === "landscape");
    const isPortrait = computed(() => orientationRef.value === "portrait");

    return {
        orientation,
        isLandscape,
        isPortrait,
    };
}
